import { convertToUrlParams } from '@/functions/convertSearchParams';
import { getSearchParamTitle } from '@/functions/getSearchParamTitle';
import { relativePath } from '@/functions/redirectToRelativePath';
import { useScrollIfHashed } from '@/hooks/useScrollControl';
import { usePathname } from 'next/navigation';

export const useEventCardList = (
  searchParams: SearchParams,
  customerSetting: CustomerSetting
) => {
  const pathname = usePathname();
  const searchQueryText = getSearchParamTitle(
    customerSetting,
    searchParams,
    pathname.includes('/today')
  );
  const ref = useScrollIfHashed('events');

  const createLink = (page: number | null) => {
    const params = convertToUrlParams({
      ...searchParams,
      page: page?.toString() ?? undefined
    });
    return relativePath(
      `/list/${params ? '?' : ''}${params}#events`,
      customerSetting.domain
    );
  };

  return { searchQueryText, ref, createLink };
};
